import { render } from "./accentDropdown.vue?vue&type=template&id=397e7992"
import script from "./accentDropdown.vue?vue&type=script&lang=js"
export * from "./accentDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__